import Footer from '../../components/footer';
import Header from '../../components/header';
import Menu from '../../components/menu';
import LayoutContextWrapper from '../../contexts/layout';
import LayoutFactory from '../../factories/layout-factory';
import useLayout from '../../hooks/layout/useLayout';

function LayoutComponent() {
    const { layout } = useLayout('main');

    return (
        <div className="wrapper d-flex flex-grow-1 flex-column">
            <Header />
            <Menu />
            <div className="content-wrapper p-3">
                <LayoutFactory layout={layout?.layout || []} data={layout?.data || {}} />
            </div>
            {layout && Array.isArray(layout.footer) && (
                <Footer layout={layout.footer} />
            )}
        </div>
    );
}

function Layout() {
    return (
        <LayoutContextWrapper layoutId="main">
            <LayoutComponent />
        </LayoutContextWrapper>
    );
}

export default Layout;
